import React, { memo, Fragment } from 'react'

const Loader = memo(({ fullScreen = true, height = '', className = '' }) => {
    const style = {
        minHeight: height ? height : fullScreen ? '85vh' : '195px',
        maxHeight: height ? height : fullScreen ? '85vh' : '195px'
    }

    return (
        <Fragment>
            <div className={`${className} iq-loader-box`} style={style}>
                <div className="iq-loader-6"> <span className="inner inner1"></span>
                    <span className="inner inner2"></span>
                    <span className="inner inner3"></span>
                </div>
            </div>
        </Fragment>
    )
})

Loader.displayName = 'Loader'
export default Loader
